import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const ReportFormatChooserType = yup.object({
   _format: yup.string().oneOf(enums.reportFormats.keys).default(enums.reportFormats.enum.PDF),
});
